import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
// import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
// import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Icon from '@material-ui/core/Icon';
// import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Scope } from 'informed';
import { withStyles } from '@material-ui/core/styles';
import { compact, defaultTo, forIn, get } from 'lodash-es';

import ExtraFields from '../../Common/ExtraFields';
import HiddenField from '../../Common/HiddenField';
import CoverageFields from './CoverageFields';
import DefaultFields from './DefaultFields';
import PartyFields from './NaturalPartyFields';
import Summary from './Summary';

import './CoveredBlock.scss';

class CoveredBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      coveredList: [{ id: -1 }],
      // eslint-disable-next-line react/no-unused-state
      selectedValue: '',
      expanded: true,
      model: {},
      type: undefined,
    };
  }

  static componentDidMount() {
    const { expanded, data } = this.props;
    this.setState({
      expanded,
    });
    // extract only first type...
    if (data.covered) {
      forIn(data.covered, (value, key) => {
        if (Array.isArray(value.extra)) {
          this.setState({
            model: value,
            type: key,
          });
          return false;
        }
        return true;
      });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { expanded, values, data } = nextProps;
    const { coveredList } = prevState;
    let newState = null;

    // extract only first type...
    if (data && data.covered) {
      forIn(data.covered, (value, key) => {
        if (Array.isArray(value.extra)) {
          newState = newState
            ? Object.assign(newState, {
              model: value,
              type: key,
            })
            : {
              model: value,
              type: key,
            };
          return false;
        }
        return true;
      });
    }
    if (
      Array.isArray(values.covered) &&
      values.covered.length > 0 &&
      coveredList.length > 0 &&
      coveredList[0].id === -1
    ) {
      newState = {
        coveredList: values.covered.map(() => ({
          id: Math.random(),
        })),
      };
    }
    if (expanded !== prevState.expanded) {
      newState = newState ? Object.assign(newState, { expanded }) : { expanded };
    }
    return newState;
  }

  componentDidUpdate(prevProps, prevState) {
    const { coveredList } = this.state;
    if (prevState.coveredList !== coveredList) {
      this.deepCleanValues();
    }
  }

  deepCleanValues = (property = 'covered') => {
    const { formApi } = this.props;
    // const { type } = this.state;
    const propertyState = defaultTo(formApi.getValue(property), []);
    const cleanPropertyState = compact(propertyState);

    formApi.setValues({ ...formApi.getState().values, [property]: compact(cleanPropertyState) });
  };

  addCovered = () => {
    this.setState(prevState => {
      if (prevState.coveredList.length > 0) {
        return {
          coveredList: [...prevState.coveredList, { id: Math.random() }],
        };
      }
      return {
        coveredList: [...prevState.coveredList, { id: -1 }],
      };
    });
  };

  removeCovered = i => {
    this.setState(prevState => {
      const coveredList = [...prevState.coveredList];
      coveredList.splice(i, 1);
      return {
        coveredList,
      };
    });
  };

  render() {
    const { expanded, coveredList, model, type, selectedValue } = this.state;
    const { formApi, onSave, strings, classes, setExpanded, i18n, ...props } = this.props;
    const { config, data, isLoan, values, readOnly, singleCovered } = props;

    // const handleSave = value => {
    //   this.setState({
    //     // eslint-disable-next-line react/no-unused-state
    //     selectedValue: value,
    //   });
    //   onSave(formApi.getState().values);
    // };

    const toggleExpanded = () => {
      setExpanded('covered', !expanded);
    };

    const getSummary = () => {
      const { covered } = formApi.getState().values;
      return <Summary covered={covered} strings={strings} config={config} />;
    };

    const coveredBlock = () => (
      <Fragment key="covered-form">
        {coveredList.map((covered, i) => (
          <div key={`covered-field-${covered.id}`} className="covered item">
            <Scope scope={`covered[${i}]`}>
              {model ? (
                <>
                  {model.kind === 'person' ? (
                    <PartyFields data={model.extra} strings={strings} config={config} readOnly={readOnly} />
                  ) : undefined}
                  <ExtraFields
                    data={get(model, 'extra', [])}
                    values={get(values, `covered[${i}].extra`, [])}
                    readOnly={readOnly}
                    formApi={formApi}
                    onSave={onSave}
                    strings={strings}
                    classes={classes}
                    i18n={i18n}
                  />
                  <DefaultFields
                    values={get(values, `covered[${i}]`, [])}
                    data={data}
                    strings={strings}
                    config={config}
                    isLoan={isLoan}
                    readOnly={readOnly}
                  />
                  <CoverageFields
                    values={values.covered[i]}
                    package={data.package}
                    strings={strings}
                    coverage={get(model, 'coverage')}
                    selectedPackage={selectedValue}
                    readOnly={readOnly}
                    covered={data.covered}
                    i18n={i18n}
                  />
                  {type ? <HiddenField field="type" value={type} initialValue={type} /> : undefined}
                  {model.kind !== 'person' ? (
                    <HiddenField
                      field="name"
                      value={`${strings['block.covered.subtitle']} Nº${i + 1}`}
                      initialValue={`${strings['block.covered.subtitle']} Nº${i + 1}`}
                    />
                  ) : undefined}
                </>
              ) : undefined}
            </Scope>
            <div className="title--sub-block">{`${strings['block.covered.subtitle']} Nº${i + 1}`}</div>
            <Tooltip
              disableHoverListener={coveredList.length <= 1 || coveredList.length > i + 1}
              title={strings['block.covered.btn.remove.label']}
              placement="left"
            >
              <div
                style={{
                  position: 'absolute',
                  top: '-21px',
                  right: '10px',
                }}
                className="remove button"
              >
                <Button
                  type="button"
                  onClick={() => this.removeCovered(i)}
                  // size="small"
                  color="secondary"
                  className={classes.button}
                  variant="fab"
                  disabled={coveredList.length <= 1 || coveredList.length > i + 1 || readOnly}
                  aria-label={strings['block.covered.btn.remove.label']}
                  style={{
                    width: '40px',
                    height: '40px',
                    margin: '0',
                  }}
                >
                  <Icon className={classes.icon}>remove</Icon>
                </Button>
              </div>
            </Tooltip>
          </div>
        ))}
      </Fragment>
    );

    return (
      <ExpansionPanel
        className={`expansion-panel ${expanded ? 'expanded' : ''}`}
        expanded={expanded}
        onChange={toggleExpanded}
      >
        <ExpansionPanelSummary
          className="expansion-panel-summary"
          expandIcon={<ExpandMoreIcon className="expansion-more-icon" />}
        >
          <span className="block-title">
            <Typography className="title">{strings['block.covered.title']}</Typography>
            <Typography className="chip">{values.covered.length}</Typography>
          </span>
          {expanded ? '' : <div className="summary">{getSummary()}</div>}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.details}>
          <div className="covered details">
            <div className="covered list">{coveredBlock()}</div>
            <div className="covered actions">
              {!singleCovered ? (
                <Tooltip title={strings['block.covered.btn.add.label']} placement="right">
                  <Button
                    type="button"
                    onClick={() => this.addCovered()}
                    disabled={readOnly}
                    // size="small"
                    color="primary"
                    className={classes.button}
                    variant="fab"
                    aria-label={strings['block.covered.btn.add.label']}
                    style={{
                      width: '40px',
                      height: '40px',
                      margin: '0',
                    }}
                  >
                    <Icon className={classes.icon}>add</Icon>
                  </Button>
                </Tooltip>
              ) : (
                <></>
              )}
            </div>
          </div>
        </ExpansionPanelDetails>
        {/* <Divider />
        <ExpansionPanelActions>
          <Button type="submit" size="small" color="primary" onClick={handleSave}>
            {strings['block.btn.save.label']}
          </Button>
        </ExpansionPanelActions> */}
      </ExpansionPanel>
    );
  }
}

CoveredBlock.propTypes = {
  formApi: PropTypes.any.isRequired, // eslint-disable-line
  data: PropTypes.any.isRequired, // eslint-disable-line
  onSave: PropTypes.func.isRequired, // eslint-disable-line
  strings: PropTypes.objectOf(PropTypes.string).isRequired,
  classes: PropTypes.any.isRequired, // eslint-disable-line
  config: PropTypes.any.isRequired, // eslint-disable-line
  values: PropTypes.any.isRequired, // eslint-disable-line
  actions: PropTypes.shape({
    fetchLenders: PropTypes.func,
    fetchLenderAddresses: PropTypes.func,
  }).isRequired,
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
  isLoan: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    lang: PropTypes.string,
  }).isRequired,
};

CoveredBlock.defaultProps = {};

const styles = theme => ({
  root: {},
  formControl: {},
  selectEmpty: {},
  button: {},
  input: {},
  details: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
    },
  },
  margin: {
    marginTop: '2px',
  },
  padding: {
    paddingRight: `${theme.spacing(2)}px`,
    fontSize: '14px',
  },
});

export default withStyles(styles)(CoveredBlock);
